
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { saveMixin } from "@/mixins/saveMixin";
import MainHeader from "@/components/main-header.vue";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";
import {
  GetTemDetail,
  PostCepingContent,
  GetPatientDetail,
  GetContentDetail,
  EditContent,
} from "@/request/common";
import { getCurrentTime } from "@/utils/base";
import { IfEmpty } from "@/components/template-transfer-pc/template/common";
@Component({
  components: {
    MainHeader,
    TemplateContent,
  },
})
export default class Name extends mixins(saveMixin) {
  private type: any = "";
  private patient_id: any = "";
  private template_id: any = "";
  private content_id: any = "";
  private template: any = {};
  private data: any = {};
  private patient: any = {};
  private disabledDate: any = this.endDate();
  private leftTabNav: any = [];
  private cLeftTab: any = "";
  private ifPlay: boolean = false;
  private playIndex: any = null;
  private currentUtterance: SpeechSynthesisUtterance | null = null;
  private keyboardHandler: ((e: KeyboardEvent) => void) | null = null;
  private redIndex: any = null;
  private get href() {
    return window.location.href;
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private goReport() {
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([this.data.id]),
      },
    });
  }
  private edit() {
    this.$store.commit("updateIfCompose", true);
  }
  private updateWholeTem(e: any) {
    this.data.data = e;
    this.$forceUpdate();
  }
  private sizhenSaveContent() {
    this.save();
  }
  private updateContent(e: any) {
    this.data = e;
  }
  /**
   * 保存前的验证
   */
  private savePre() {
    return new Promise((resolve, reject) => {
      // 判断必填项是否填完
      for (let i = 0; i < this.data.data.length; i++) {
        const weitian = IfEmpty(this.data.data[i]);
        if (weitian) {
          // 弹提示哪个未填,并用红框框上
          this.$message.warning(this.data.data[i].title + "为必填项！");
          this.redIndex = i;
          // 滚动到没填的题目
          const parent = (document as any).getElementById("liangbiao-detail");
          const child = (document as any).getElementById("liangbiao" + i);
          parent.scrollTop = child.offsetTop - parent.offsetTop;
          resolve(false);
          return;
        }
      }
      resolve(true);
    });
  }
  save() {
    return new Promise((resolve, reject) => {
      this.savePre().then((res: any) => {
        if (res) {
          // 必填验证成功
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.content_id || this.data.id) {
            EditContent(
              this,
              this.content_id || this.data.id,
              this.data,
              loading
            ).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              this.data = res.data;
              // this.getData();
              resolve(true);
            });
          } else {
            if (!this.data.related_type) {
              this.data.related_type = this.type;
            }
            PostCepingContent(this, this.data, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              // this.$router.back();
              this.getData(res.data.id);
              resolve(res);
            });
          }
        } else {
          // 必填验证失败
        }
      });
    });
  }
  private getTemplate() {
    if (!this.template_id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemDetail(this, this.template_id, loading)
      .then((res: any) => {
        loading.close();
        this.template = res.data;
        if (!this.content_id) {
          const d: any = JSON.parse(JSON.stringify(res.data));
          this.data = {
            patient: this.patient_id,
            template: d,
            data: d.fields,
            collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
          };
          this.getLeftTab();
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getData(id?: any) {
    if ((!this.content_id || this.data.id) && !id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.content_id || id, loading)
      .then((res: any) => {
        loading.close();
        // 模拟数据
        // if (res.data.template.name == "舌象数据") {
        //   if (!res.data.report) {
        //     res.data.report = {};
        //   }
        //   if (!res.data.report["舌色参数"]) {
        //     res.data.report["舌色参数"] = [
        //       ["56.59", "57.61", "41.94", "57.28", "56.66", "59.57"],
        //       ["30.30", "30.64", "25.89", "29.19", "29.83", "32.85"],
        //       ["14.22", "14.34", "14.46", "14.05", "14.00", "14.32"],
        //       ["淡红", "", "", "", "", ""],
        //     ];
        //     res.data.report["苔色参数"] = [
        //       ["56.02", "58.69", "50.95", "58.31", "58.50", "58.55"],
        //       ["25.85", "26.81", "24.65", "25.34", "26.00", "27.03"],
        //       ["17.15", "17.41", "17.75", "15.70", "15.93", "14.31"],
        //       ["苔白", "", "", "", "", ""],
        //     ];
        //     res.data.report["舌象信息输出"] = [
        //       "淡红",
        //       "无",
        //       "无",
        //       "苔白",
        //       "薄",
        //       "无",
        //       "无",
        //       "无",
        //       "适中",
        //       "有",
        //       "无",
        //       "有",
        //     ];
        //   }
        // }
        // if (res.data.template.name == "面象数据") {
        //   if (!res.data.report) {
        //     res.data.report = {};
        //     res.data.report["面色唇色参数"] = [
        //       ["57.68", "53.93", "51.97", "51.97", "51.94", "58.37", "47.64"],
        //       ["24.59", "21.62", "12.88", "12.88", "12.24", "25.22", "35.35"],
        //       ["22.24", "22.98", "10.96", "10.96", "11.21", "22.52", "16.18"],
        //       ["面色赤", "", "", "", "", "", "唇色红"],
        //     ];
        //     res.data.report["面象信息输出"] = [
        //       "面色赤",
        //       "无",
        //       "无",
        //       "少量光泽",
        //       "唇色红",
        //     ];
        //   }
        // }
        // if (res.data.template.name == "脉象数据") {
        //   if (!res.data.report) {
        //     res.data.result="中"
        //     res.data.report = {};
        //     res.data.report["右手分段压脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_subsetionpulseimage.jpg";
        //     res.data.report["右手最佳压力脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d-12460-r.jpg";
        //     res.data.report["右手连续脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_rhythmimage.jpg";
        //     res.data.report["右手脉象p-h趋势图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_trendimage.jpg";
        //     res.data.report["左手分段压脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_subsetionpulseimage.jpg";
        //     res.data.report["左手最佳压力脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d-12460-r.jpg";
        //     res.data.report["左手连续脉图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_rhythmimage.jpg";
        //     res.data.report["左手脉象p-h趋势图"] =
        //       "https://gyhl.oss-cn-shanghai.aliyuncs.com/pulse/12460/ce06ce3ac5f242c19836d01caab5479d/ce06ce3ac5f242c19836d01caab5479d_12460_2_trendimage.jpg";

        //     res.data.report["左手最佳脉象图参数"] = {
        //       A: 123.271,
        //       Ad: 48.625,
        //       As: 74.646,
        //       h1: 16.64,
        //       h2: 10.739,
        //       h3: 9.604,
        //       "h3/h1": 0.5772,
        //       h4: 7.033,
        //       "h4/h1": 0.4227,
        //       h5: 1.125,
        //       "h5/h1": 0.0676,
        //       t: 0.831,
        //       t1: 0.114,
        //       "t1/t": 0.1372,
        //       t2: 0.194,
        //       t3: 0.225,
        //       t4: 0.3,
        //       t5: 0.53,
        //       "t5/t4": 1.7667,
        //       w1: 0.124,
        //       "w1/t": 0.1492,
        //       w2: 0.082,
        //       "w2/t": 0.0987,
        //     };
        //     res.data.report["左手脉象信息输出"] = {
        //       流利度: "无滑、涩特征",
        //       紧张度: "无弦、紧特征",
        //       脉位: "沉",
        //       脉力: "中",
        //       脉名: "脉浮而结",
        //       脉率: "慢(72times/min)",
        //       脉节律: "不齐",
        //     };
        //     res.data.report["右手最佳脉象图参数"] = {
        //       A: 123.271,
        //       Ad: 48.625,
        //       As: 74.646,
        //       h1: 16.64,
        //       h2: 10.739,
        //       h3: 9.604,
        //       "h3/h1": 0.5772,
        //       h4: 7.033,
        //       "h4/h1": 0.4227,
        //       h5: 1.125,
        //       "h5/h1": 0.0676,
        //       t: 0.831,
        //       t1: 0.114,
        //       "t1/t": 0.1372,
        //       t2: 0.194,
        //       t3: 0.225,
        //       t4: 0.3,
        //       t5: 0.53,
        //       "t5/t4": 1.7667,
        //       w1: 0.124,
        //       "w1/t": 0.1492,
        //       w2: 0.082,
        //       "w2/t": 0.0987,
        //     };
        //     res.data.report["右手脉象信息输出"] = {
        //       流利度: "无滑、涩特征",
        //       紧张度: "无弦、紧特征",
        //       脉位: "沉",
        //       脉力: "中",
        //       脉名: "脉浮而结",
        //       脉率: "慢(72times/min)",
        //       脉节律: "不齐",
        //     };
        //   }
        // }
        this.data = res.data;
        this.getLeftTab();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getPatientData() {
    if (!this.patient_id) {
      return;
    }
    GetPatientDetail(this, this.patient_id).then((res: any) => {
      this.patient = res.data;
    });
  }
  private startPlayAudio() {
    this.$store.commit("updateIfCompose", false);
    this.ifPlay = true;
    this.playIndex = 0;
    // 添加键盘事件监听
    this.keyboardHandler = this.handleKeyboardInput.bind(this);
    window.addEventListener("keydown", this.keyboardHandler);
    // 需要清除所有题目的值
    this.data.data.forEach((item: any) => {
      if (item.type == "计分单选") {
        item.value = {};
      }
    });
    this.playAudio(0);
    // 页面滚动到最上面
    const parent = (document as any).getElementById("liangbiao-detail");
    parent.scrollTop = 0;
  }
  private stopPlayAudio() {
    this.ifPlay = false;
    this.$store.commit("updateIfCompose", true);
    this.playIndex = null;
    // 移除键盘事件监听
    if (this.keyboardHandler) {
      window.removeEventListener("keydown", this.keyboardHandler);
      this.keyboardHandler = null;
    }
    this.stopAudio();
  }
  private async playAudio(index: any) {
    if (
      (this.data.data[index].type != "单选" &&
        this.data.data[index].type != "计分单选" &&
        this.data.data[index].type != "计分条") ||
      this.data.data[index].hide
    ) {
      this.playAudio(index + 1);
      return;
    } else {
      this.playIndex = index;
      // 这里需要判断下，如果下一题不在可视区域，则滚动到下一题
      const nextQuestion = document.getElementById(`liangbiao${index}`);
      if (nextQuestion) {
        const parent = (document as any).getElementById("liangbiao-detail");
        // 获取parent的高度
        const parentHeight = parent.offsetHeight;
        // 获取nextQuestion的高度
        const nextQuestionHeight = nextQuestion.offsetHeight;
        // 如果nextQuestion不在可视区域，则滚动到下一题
        if (
          nextQuestion.offsetTop + nextQuestionHeight >
          parentHeight + parent.offsetTop + parent.scrollTop
        ) {
          parent.scrollTop =
            nextQuestion.offsetTop +
            nextQuestionHeight -
            parentHeight -
            parent.offsetTop;
        }
      }
    }
    //前端语音读题,把文字生成语音读出来
    const text = this.data.data[index].title;
    await this.playCountdown(text);
  }
  private stopAudio() {
    if (this.currentUtterance) {
      this.currentUtterance.onend = null;
      this.currentUtterance = null;
    }
    window.speechSynthesis.cancel();
  }
  private playCountdown(val: any): Promise<void> {
    return new Promise((resolve) => {
      this.stopAudio();

      // 其他题目编辑状态改为false,当前题目编辑状态改为true
      this.data.data.forEach((item: any, index: any) => {
        item.edit = index == this.playIndex;
      });
      const text = val;
      const utterance = new SpeechSynthesisUtterance(text);
      this.currentUtterance = utterance;

      // 设置中文语音
      const voices = window.speechSynthesis.getVoices();
      const chineseVoice = voices.find((voice) => voice.lang.startsWith("zh"));
      if (chineseVoice) {
        utterance.voice = chineseVoice;
      }

      utterance.onend = () => {
        this.currentUtterance = null;
        resolve();
      };

      window.speechSynthesis.speak(utterance);
    });
  }
  private radioScoreClick(option: any, optionIndex: any, tIndex: any) {
    if (!this.ifCompose && !this.data.data[tIndex].edit) {
      return;
    }
    if (
      this.data.data[tIndex].value &&
      this.data.data[tIndex].value.name &&
      this.data.data[tIndex].value.name === option.name
    ) {
      this.data.data[tIndex].value = {};
    } else {
      this.data.data[tIndex].value = option;
    }
    this.$forceUpdate();
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          (this.data.data[i].hide == true &&
            this.data.data[i].type != "段落标题") ||
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }
  }
  private radioClick(ev: any, tIndex: any) {
    if (!this.ifCompose && !this.data.data[tIndex].edit) {
      return;
    }
    this.data.data[tIndex].value === ev
      ? (this.data.data[tIndex].value = "")
      : (this.data.data[tIndex].value = ev);
    this.$forceUpdate();
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          !this.data.data[i].hide &&
          this.data.data[i].type != "段落标题" &&
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }

    // this.changeHide();
  }
  private scrollTo(item: any) {
    if (this.ifPlay) {
      this.$message.warning("请先关闭语音播放");
      return;
    }
    this.cLeftTab = item.title;
    const parent = (document as any).getElementById("liangbiao-detail");
    const child = (document as any).getElementById("liangbiao" + item.index);
    parent.scrollTop = child.offsetTop - parent.offsetTop;
  }
  private scrollEvent() {
    const parent = (document as any).getElementById("liangbiao-detail");
    if (parent) {
      const scrollTop = parent.scrollTop;
      const parentTop = parent.offsetTop + 14;
      this.data.data.forEach((ele: any, i: any) => {
        if (i < this.leftTabNav.length) {
          const cuEle = document.getElementById("liangbiao" + i);
          const nextEle = document.getElementById("liangbiao" + (i + 1));
          if (cuEle && nextEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            const nextTop = nextEle.offsetTop - parentTop;
            if (scrollTop >= cuTop && scrollTop < nextTop) {
              // 找到对应的leftTabNav
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        } else {
          const cuEle = document.getElementById("liangbiao" + i);
          if (cuEle) {
            const cuTop = cuEle.offsetTop - parentTop;
            if (scrollTop >= cuTop) {
              const findLeftTabNav = this.leftTabNav.find(
                (item: any) => item.index == i
              );
              if (findLeftTabNav) {
                this.cLeftTab = findLeftTabNav.title;
              }
            }
          }
        }
      });
    }
  }
  private getLeftTab() {
    let leftTabNav: any = [];
    this.data.data.forEach((items: any, index: any) => {
      if (items.group) {
        // 如果标题结尾是“判定”，则不加入左侧导航
        leftTabNav.push({ ...items, children: [], index: index });
      } else {
        if (leftTabNav.length > 0) {
          leftTabNav[leftTabNav.length - 1].children.push(items);
        }
      }
    });
    this.leftTabNav = leftTabNav;
    if (leftTabNav.length > 0) {
      this.cLeftTab = leftTabNav[0].title;
    }
  }
  beforeDestroy() {
    // 确保在组件销毁时移除事件监听
    if (this.keyboardHandler) {
      window.removeEventListener("keydown", this.keyboardHandler);
    }
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    this.stopAudio();
  }
  private handleKeyboardInput(e: KeyboardEvent) {
    if (!this.ifPlay || this.playIndex === null) return;

    const currentQuestion = this.data.data[this.playIndex];
    if (!currentQuestion || !currentQuestion.options) return;

    // 只处理数字键
    const key = parseInt(e.key);
    if (isNaN(key)) return;

    // 检查选项是否存在
    if (key > 0 && key <= currentQuestion.options.length) {
      // 单选直接设置值
      const option = currentQuestion.options[key - 1];
      if (currentQuestion.type == "计分单选") {
        this.radioScoreClick(option, key - 1, this.playIndex);
      } else {
        this.radioClick(option, this.playIndex);
      }
    }
  }
  private formatTooltio(val: any) {
    return val;
  }
  private jifenChange(tIndex: any) {
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          !this.data.data[i].hide &&
          this.data.data[i].type != "段落标题" &&
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }
  }
  mounted() {
    if (this.$route.query.patient_id) {
      this.patient_id = this.$route.query.patient_id;
      this.getPatientData();
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.template_id) {
      this.template_id = this.$route.query.template_id;
      this.getTemplate();
    }
    if (this.$route.query.content_id) {
      this.content_id = this.$route.query.content_id;
      this.getData();
    }
  }
}
